import { Component } from '@angular/core';

import { environment } from './../environments/environment';
import { LoadingIndicatorService } from 'src/services/loading-indicator.service';

@Component({
    selector: 'app-root',
    templateUrl: './app.component.html',
    styleUrls: ['./app.component.css']
})
export class AppComponent {
    loading = false;
    sub: any;

    constructor(private loadingIndicatorService: LoadingIndicatorService) {
        // init requires object with clientId and tenant properties
        this.sub = loadingIndicatorService.onLoadingChanged.subscribe(isLoading => this.loading = isLoading);
    }

    ngOnInit() {
    }

    ngOnDestroy() {
        if (this.sub)
            this.sub.unsubscribe();
    }
}
